import { ValidatorFn, FormGroup, ValidationErrors, AbstractControl } from '@angular/forms';
import { setError } from './setError';

export function MutexValidator(names: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
    if (!(control instanceof FormGroup)) {
        return null;
    }

    const group = control;
    const values: {value: any, controls: AbstractControl[]}[] = [];
    for (const name of names) {
        const control = group.get(name);
        if (control) {
            const value = values.find(x => x.value === control.value);
            if (value) {
                value.controls.push(control);
            } else {
                values.push({value: control.value, controls: [control]});
            }
        }
    }

    if (values.length > 0) {
        for (const value of values) {
            const error = value.controls.length > 1 ? { mutex: `Can't have the same value: ${value.value}` } : null;
            for (const control of value.controls) {
                setError(control, error, 'mutex');
            }
        }
    }

    return null;
  };
}

